var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgFirstPage = function SvgFirstPage(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    "aria-label": "First Page",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u21B3-Icons-\\uD83D\\uDD04",
    stroke: "none",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("g", {
    id: "AZ_DLS_Icons",
    transform: "translate(-869.000000, -345.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "First-page",
    transform: "translate(869.000000, 345.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.69875,15.89 L13.81875,12 L17.70875,8.11 C18.09875,7.72 18.09875,7.09 17.70875,6.7 C17.5219185,6.51274733 17.2682676,6.40751439 17.00375,6.40751439 C16.7392324,6.40751439 16.4855815,6.51274733 16.29875,6.7 L11.70875,11.29 C11.31875,11.68 11.31875,12.31 11.70875,12.7 L16.29875,17.29 C16.68875,17.68 17.31875,17.68 17.70875,17.29 C18.08875,16.91 18.08875,16.27 17.69875,15.89 Z M6.99875,6 C7.54875,6 7.99875,6.45 7.99875,7 L7.99875,17 C7.99875,17.55 7.54875,18 6.99875,18 C6.44875,18 5.99875,17.55 5.99875,17 L5.99875,7 C5.99875,6.45 6.44875,6 6.99875,6 Z",
    id: "icon_first-page"
  }))))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgFirstPage);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "first-page.24540fb6bd762f9cabd0e0da467d8f7c.svg";